import { defaultStoreId } from "./apiEndpoints";

const geoLocationOptions = {
  enableHighAccuracy: true,
  timeout: 6000,
  maximumAge: 120000,
};

export default { geoLocationOptions, defaultStoreId };
